/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const CustomFieldTemplateStyles = makeStyles(() => ({
  root: {
    padding: 0,
    margin: 0,
  },
  listItem: {
    padding: 0,
  },
  helper: {
    padding: '0 16px',
    color: '#FA634E',
    fontSize: '12px',
    lineHeight: '16px',
  },
  fieldWrapper: {
    margin: 0,
    padding: 0,
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    display: 'flex',
  },
}));
